import React, { useState, useEffect } from 'react';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import TabPanel from '../common/tabpanel';
import Grid from '@mui/material/Grid';
import UserManagementView from './usermanagementview';
import ProductionPlanning2 from './productionplanning2';
import ViewHelper from '../common/viewhelper';
import PortfolioManagementView from './portfoliomanagementview';
import TenantCompanyManagementView from './tenantcompanymanagementview';
import { ParameterManagement } from './parametermanagement';
import { useTranslation } from 'react-i18next';
import ContractMgmt from './contracts';

const styles = {
    tab: {
        width: '100%',
    },
    tabBarCenter: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
    },
};

const AdminContainer = (props) => {
    const [selectedView, setSelectedView] = useState(0);
    const { t } = useTranslation();

    const views = new ViewHelper({
        '#admin': 0,
        '#portfolio': 1,
        '#parameters': 2,
        '#productionplanning': 3,
        '#newproductionplanning': 4,
        '#contracts': 5,
        '#tenantcompanies': 6,
    });

    const handleChange = (event, value) => {
        props.history.replace('/admin' + views.getViewName(value));
        setSelectedView(value);
    };

    const selectViewFromUrl = () => {
        let correctView = views.getViewId(props.history.location.hash);
        if (selectedView !== correctView) {
            setSelectedView(correctView);
        }
    };

    useEffect(() => {
        selectViewFromUrl();
    });

    return (
        <Grid container>
            <AppBar position="static" color="default">
                <Box sx={styles.tabBarCenter}>
                    <Tabs
                        value={selectedView}
                        onChange={handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="scrollable"
                        scrollButtons="auto">
                        <Tab value={0} label={t('admin.users')} />
                        <Tab value={1} label={t('admin.portfolios')} />
                        <Tab value={2} label={t('admin.parameters')} />
                        <Tab value={5} label={t('admin.contracts')} />
                        <Tab value={3} label={t('admin.prodPlanning')} />
                        <Tab value={6} label={t('admin.tenantCompanies')} />
                    </Tabs>
                </Box>
            </AppBar>
            <TabPanel value={selectedView} index={0} sx={styles.tab}>
                <UserManagementView history={props.history} active={selectedView === 0} />
            </TabPanel>
            <TabPanel value={selectedView} index={1} sx={styles.tab}>
                <PortfolioManagementView history={props.history} active={selectedView === 1} />
            </TabPanel>
            <TabPanel value={selectedView} index={2} sx={styles.tab}>
                <ParameterManagement history={props.history} active={selectedView === 2} />
            </TabPanel>
            <TabPanel value={selectedView} index={5} sx={styles.tab}>
                <ContractMgmt />
            </TabPanel>
            <TabPanel value={selectedView} index={3} sx={styles.tab}>
                <ProductionPlanning2 history={props.history} active={selectedView === 3} />
            </TabPanel>
            <TabPanel value={selectedView} index={6} sx={styles.tab}>
                <TenantCompanyManagementView history={props.history} active={selectedView === 6} />
            </TabPanel>
        </Grid>
    );
};

export default AdminContainer;
